import React from 'react'
import Modal from "react-bootstrap/Modal";
const ErrorMassagePupUp = ({ show, onHide, Massage }) => {
    return (
        <>
            <Modal
                show={show}
                // onHide={onHide}
                onHide={() => {
                    onHide();

                }}
                backdrop="static"
                keyboard={false}
                centered
                dialogClassName="custom-modal-width"
            >
                <Modal.Header
                    closeButton

                >

                </Modal.Header>
                <Modal.Body
                    style={{
                        //   backgroundColor: "#f2eeee",
                        color: "Black",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        minHeight: "80px", // Ensures proper vertical centering
                    }}
                >
                    <h6>{Massage}</h6>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ErrorMassagePupUp
